// const MOCK_REPORT_DATA = [
//   {
//     metrics: {
//       canceled: 0,
//       removed: 10,
//       failed: 2,
//       rejected: 2,
//       queued: 2,
//       updated: 54,
//       inProgress: 2,
//       neverAttempted: 2
//     }
//   }
// ];

import { selectMarkets } from "../../../../../state/selectors";
import { getState } from "../../../../../state/store";

const formatSettingsData = (campaignName, settingsData) => {
  const { selectedMarkets, versions, oldMarkets, oldVersions } = settingsData;

  const markets = [
    ...(oldMarkets ?? []).map((m) => m.id),
    ...(selectedMarkets ?? []).map((m) => m.id)
  ];
  const currentFwVersions = [
    ...(oldVersions ?? [])?.map((v) => v.id),
    ...(versions ?? [])?.map((v) => v.id)
  ];

  const result = {
    campaign_name: campaignName,

    current_fw_versions: currentFwVersions,
    markets: markets
  };

  return result;
};

const formatFWUCampaignDetails = (fwuCampaignDetails) => {
  const data = [];

  if (fwuCampaignDetails) {
    const {
      numberOfCanceledThings = 0,
      numberOfRemovedThings = 0,
      numberOfFailedThings = 0,
      numberOfRejectedThings = 0,
      numberOfQueuedThings = 0,
      numberOfSucceededThings = 0,
      numberOfInProgressThings = 0,
      numberOfNotAttemptedThings = 0
    } = fwuCampaignDetails;

    const formattedDetails = {
      metrics: {
        canceled: numberOfCanceledThings,
        removed: numberOfRemovedThings,
        failed: numberOfFailedThings,
        rejected: numberOfRejectedThings,
        queued: numberOfQueuedThings,
        updated: numberOfSucceededThings,
        inProgress: numberOfInProgressThings,
        neverAttempted: numberOfNotAttemptedThings
      }
    };

    data.push(formattedDetails);
  }

  return data;
};

const formatNotificationCampaignDetails = (notificationCampaignDetails) => {
  const received = notificationCampaignDetails?.report?.markets?.reduce(
    (previousValue, currentValue) => (previousValue += currentValue.received),
    0
  );

  const waitingResponse = notificationCampaignDetails?.report?.markets?.reduce(
    (previousValue, currentValue) => (previousValue += currentValue.total - currentValue.received),
    0
  );

  return [
    {
      metrics: {
        received: received || 0,
        waitingResponse: waitingResponse || 0
      }
    }
  ];
};

const formatNotificationCampaignMarketDetails = (notificationCampaignDetails) => {
  const markets = selectMarkets()(getState());

  const details = [];

  notificationCampaignDetails?.report?.markets?.forEach((report) => {
    details.push({
      market: markets?.find((market) => market.market === report.market)?.name || report.market,
      totalDetails: `(${report.received}/${report.total})`,
      report: [
        {
          metrics: {
            received: report.received,
            waitingResponse: report.total - report.received
          }
        }
      ]
    });
  });

  return details;
};

export const formatUtils = {
  formatSettingsData,
  formatFWUCampaignDetails,
  formatNotificationCampaignDetails,
  formatNotificationCampaignMarketDetails
};
